// extracted by mini-css-extract-plugin
export default {"innerWrapper":"SC-z","tooltipWrapper":"TC-z","icon":"UC-z","tooltip":"VC-z","content":"WC-z"};